import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image';
import React, { Component } from 'react'
const quickSand = Quicksand({weight:"400",subsets:['latin']});
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "400", subsets: ['latin']});
export default class Coursefeature extends Component {
  render() {
    const CourseFeaturesData=[
      {
        title:"Expert Trainers",
        content:`Learn from experienced instructors who are experts in the field of ${this.props.title}, providing you with valuable insights and guidance throughout the course.`,
        img:"/course-img/course-features-img/trainer-img.webp",
      },
      {
        title:"Customizable Schedule",
        content:"Learnsoft features a flexible framework, empowering our users to easily and swiftly customize their learning experiences.",
        img:"/course-img/course-features-img/schedule-img.webp",
      },
      {
        title:"Real-time projects",
        content:"Real-time projects offer hands-on experience in real-world scenarios, enhancing practical skills and knowledge.",
        img:"/course-img/course-features-img/project-img.webp",
      },
      {
        title:"Updated Course Curriculum",
        content:"Updated course curriculum offers relevant and current content to ensure learners receive the most up-to-date education in their field.",
        img:"/course-img/course-features-img/curriculum-img.webp",
      },
      {
        title:"Placement Assistance",
        content:"Placement assistance provides support and guidance to help individuals secure job placements or internships in their desired field.",
        img:"/course-img/course-features-img/placement-img.webp",
      },
      {
        title:"Practical Assessments",
        content:"Practical assessments apply learned knowledge in real-world scenarios, practical skill development and effective learning.",
        img:"/course-img/course-features-img/assesment-img.webp",
      },
    ]
    return (
      <>
      
      <section className='pdt40 mpdt20'>
        <div className='container'>
        <div className=''>
            <h2 className={`fs40 lh5 mlhs30 mfs-20 tac ylw-clr mtal ${popins.className}`}>
            Key Features of {this.props.title} {this.props.location1}
            </h2>
            <p className={`fs-19 mfs14 pdt20 mpdt10 mlhs20 taj con-1000 dim-clr mtal ${extraPopins.className}`}>Our institute's {this.props.title} course offers a unique blend of cutting-edge curriculum, expert instructors, and hands-on learning experiences designed to equip students with the skills needed to excel in their careers. Key features include industry-relevant modules, flexible online and offline class schedules, personalized mentoring, and a robust support system to ensure academic success. Additionally, our course provides exclusive access to real-world projects, networking opportunities with industry leaders, and a globally recognized certification upon completion. Enroll today to transform your professional journey with our innovative and dynamic educational program</p>
        </div>
        <div className='df fw fjsb mfdc mfac' >
        {CourseFeaturesData.map((items,index)=>{
         return(
       
           
            <div className='feature-box pdt24 pdl10 df fjse mt32' key={index}>
             <div className='' >
              <h3 className={`fs-20 mfs-16 ${popins.className}`}>{items.title}</h3>
              <p className={`fs-16 mfs-14 pdt16 taj ${quickSand.className}`}>{items.content}</p>
              </div>
              <div className='df fac mdn pos-r'>
                <Image src={items.img} alt='Exper-Trainer-Img' width={"180"} height={"210"} loading='lazy'/>
              </div>
              <div className='mdf mfac dn'>
                <Image src={items.img} alt='Exper-Trainer-Img' width={"137"} height={"160"} loading='lazy'/>
              </div>
            </div>
 
         )})}
        </div>
                   
        </div>
      </section>
      
<style jsx>
    {`
       .con-1000{
        max-width:1050px;
        width:100%;
        height:100%;
        margin:0 auto;
    }
    .cnt-box{
        max-width:210px;

    }
    // .img-box{
    //     background-color: rgba(254, 167, 0, 0.5);
    //     width: 100px;
    //     height: 150px;

    // }
    .feature-box{
        width: 392px;
        height:222px;
        border-radius: 24px;
        box-shadow: 0px 4px 16px 0px #FFA70040;
        background-color: #FFFFFF;
    }
    @media only screen and (max-width: 352px){
        .feature-box{
            width: 270px;
            height:100%;
            border-radius: 16px;
            box-shadow: 0px 4px 16px 0px #FFA70040;
            background-color: #FFFFFF;
            padding:12px;
        }  
    }
    @media only screen and (min-width: 353px) and (max-width:1023px){
      .feature-box{
          width: 320px;
          height:100%;
          border-radius: 16px;
          box-shadow: 0px 4px 16px 0px #FFA70040;
          background-color: #FFFFFF;
          padding:12px;
      }  
  }
    `}
</style>

      </>
    )
  }
}
